import { Container } from 'react-bootstrap';
import Banner from '../Component/Banner';
import Footer from '../Content/Footer';

function checkLightMode() {
    if (sessionStorage.getItem('lightMode') === 'true')  {
      return true
    }
  }

const QuizTrivias = () => {

    return (
            <>
                <Container>
                        <Banner caption="Quiz Trivias"/>
                <Banner caption="Aloha" />
                <div className='text-center'>
                <h4>Here are the list of Trivias available:</h4>
                    <div className='Apps'>
                        <h1><a href='/QuizTrivias/RusselRica'>Russel and Rica's Trivia</a></h1>
                        <h1><a href='/QuizTrivias/Yoonseo'>Yoonseo's Trivia</a></h1>
                        <h1><a href='/QuizTrivias/Karol'>Karol's Results</a></h1>
                        <h1><a href='/QuizTrivias/June2026'>June 2026 Birthday</a></h1>
                    </div>
                </div>
                </Container>
                <Footer testProps= { checkLightMode() ? "lightMode" : "darkMode" }/>
            </>
    )
}

export default QuizTrivias;